module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integrations-container"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full"
  }, [_c('div', {
    staticClass: "flex items-center font-semibold text-base"
  }, [(_vm.code === 'google-classroom') ? _c('img', {
    staticClass: "w-8 h-8 rounded-full",
    attrs: {
      "src": _vm.icon
    }
  }) : _c('img', {
    staticClass: "w-8 h-8 rounded-full",
    attrs: {
      "src": ("/static/integrations/" + _vm.title + ".png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-3 h-full"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [
    [(!_vm.integration_connected) ? _c('button', {
      staticClass: "py-2 w-36 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
      on: {
        "click": _vm.connectIntegration
      }
    }, [_vm._v("\n          Connect\n        ")]) : _c('button', {
      staticClass: "py-2 w-36 bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50",
      on: {
        "click": _vm.disconnectIntegration
      }
    }, [_vm._v("\n          Disconnect\n        ")])]
  ], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-fbef74ba!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/integrationStudentCard.vue
// module id = 1039
// module chunks = 61